import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_bianji",
  "use": "icon-icon_bianji-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-icon_bianji\">\n<style type=\"text/css\">\n\t#icon-icon_bianji .st0{fill:#FFFFFF;}\n\t#icon-icon_bianji .st1{fill:#040000;}\n\t#icon-icon_bianji .st2{fill-rule:evenodd;clip-rule:evenodd;}\n</style>\n<path d=\"M870.2,816H153.8c-22,0-39.8,17.8-39.8,39.8c0,22,17.8,39.8,39.8,39.8h716.4c22,0,39.8-17.8,39.8-39.8\n\tC910,833.8,892.2,816,870.2,816z M258.24,708.03h132.62c9.63,0,18.83-3.82,25.63-10.62L791.4,322.34c14.16-14.16,14.16-37.1,0-51.26\n\tL658.99,138.6c-13.59-13.59-37.63-13.61-51.3,0.02L232.57,514.17c-6.76,6.8-10.59,16.04-10.59,25.63v131.98\n\tC221.98,691.82,238.2,708.03,258.24,708.03z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon_bianji.svg
// module id = DbRL
// module chunks = 103